import { render } from "./NewsDynamicChart.vue?vue&type=template&id=61b48796&scoped=true"
import script from "./NewsDynamicChart.vue?vue&type=script&lang=js"
export * from "./NewsDynamicChart.vue?vue&type=script&lang=js"

import "./NewsDynamicChart.vue?vue&type=style&index=0&id=61b48796&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b48796"]])

export default __exports__